import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './style.module.scss';
export default function SelectField({ label, value, options = [], onSetValue, 
//   placeholder,
required, autoFocus, ...rest }) {
    return (_jsxs("div", { className: styles['select-field'], ...rest, children: [label && _jsx("label", { children: label }), _jsx("select", { value: value, onChange: (e) => onSetValue(e.target.value), children: options.map((c) => (_jsx("option", { value: c.id, children: c.label }, c.id))) })] }));
}
